import { makeActionCreator } from '../../../redux-util/general-helpers';

export const applyFilters = makeActionCreator(
  'ui.teacher.taxonomyFilters.APPLY_FILTERS',
  'data'
);

export const setFilter = makeActionCreator(
  'ui.teacher.taxonomyFilters.SET_FILTER',
  'taxonomy',
  'name',
  'value'
);

export const clearFilters = makeActionCreator(
  'ui.teacher.taxonomyFilters.CLEAR_FILTERS'
);

export const clearSingleFilter = makeActionCreator(
  'ui.teacher.taxonomyFilters.RESET_FILTER',
  'name'
);
